import { Component, OnInit } from '@angular/core';
import { WorkspaceSwitcherService } from '~/core/services/workspace.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    standalone: false
})
export class AdminComponent implements OnInit {
    public currentWorkspace: string = '';

    constructor(private workspaceSwitcherService: WorkspaceSwitcherService) {}

    ngOnInit(): void {
        this.workspaceSwitcherService.currentWorkspace$
            .subscribe(workspace => {
                this.currentWorkspace = workspace;
                console.log('[AdminComponent] Current workspace:', workspace);
            });
    }

    /**
     * Get display name for the workspace
     */
    public getWorkspaceDisplayName(): string {
        const roleNames: { [key: string]: string } = {
            'admin': 'Admin',
            'legal': 'Legal',
            'developer': 'Developer'
        };
        return roleNames[this.currentWorkspace] || this.currentWorkspace.charAt(0).toUpperCase() + this.currentWorkspace.slice(1);
    }
}
